import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  nextSectionButton: {
    minHeight: '32px',
    marginBottom: '40px',
  },
}));

export default useStyles;
